import { apiPost } from 'api';
import { UpdateAnswerResponse, UpdateAnswerRequest } from '../../types';

export const updateAnswer = (request: UpdateAnswerRequest): Promise<UpdateAnswerResponse> => {
  return apiPost<UpdateAnswerResponse, UpdateAnswerRequest>(
    `consultations/${request.consultationId}/answers`,
    request
  );
};
